import {
    OnResultFunction,
    QrReader
} from "react-qr-reader";

import { useSnackbar } from "notistack";

type LinkQRCodeScannerProps = {
    onValidLinkScanned: (uuid: string) => (void | Promise<void>);
};

// The QR code should be in the format: /redirect/{UUID}
const redirectLinkRegex = /^.+\/redirect\/([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})\/?$/;

export const LinkQRCodeScanner = (props: LinkQRCodeScannerProps) => {
    const { onValidLinkScanned } = props;
    const snackbar = useSnackbar();

    const onQRCodeResult: OnResultFunction = async (result, error) => {
        if (error || !result) {
            return;
        }
        try {
            const incomingText = result.getText();
            const match = incomingText.match(redirectLinkRegex);
            if (!match) {
                throw new Error("Invalid QR code");
            }
            const uuid = match[1];  // The UUID is in the first capturing group
            await onValidLinkScanned(uuid);
        } catch (error) {
            snackbar.enqueueSnackbar(`Failed to read QR code: ${(error as Error).message}`, { variant: "error" });
            return;
        }
    };

    return (
        <QrReader
            constraints={{ facingMode: "environment" }}
            onResult={onQRCodeResult}
            videoStyle={{ objectFit: "cover" }}
        />
    );
};